/**
 * Created by Administrador on 22/09/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('luggageRuleService', luggageRuleService);

    luggageRuleService.$inject = ['$http', 'CONFIG', 'messageService'];

    function luggageRuleService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FARE_CONTROL + '/' + CONFIG.API + '/luggages';
        var service = {
            getLuggageRules: getLuggageRules,
            getLuggageRule: getLuggageRule,
            saveLuggageRule: saveLuggageRule,
            updateLuggageRule: updateLuggageRule,
            deleteLuggageRule: deleteLuggageRule
        }

        return service;

        function getLuggageRules(page, size, detailed){
            return $http.get(urlBase + '?detailed='+detailed+'&page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getLuggageRule(luggageRuleId){
            return $http.get(urlBase + '/' + luggageRuleId)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function saveLuggageRule(luggageRule){
            return $http.post(urlBase, luggageRule)
                .then(function(response){
                    messageService.register('luggageRules');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('luggageRules');
                });
        }

        function updateLuggageRule(luggageRuleId, luggageRule){
            return $http.put(urlBase + "/" + luggageRuleId, luggageRule)
                .then(function(response){
                    messageService.registerUpdate('luggageRules');
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdate('luggageRules');
                });
        }

        function deleteLuggageRule(luggageRuleId){
            return $http.delete(urlBase + "/" + luggageRuleId)
                .then(function(response){
                    messageService.registerDelete('luggageRules');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('luggageRules');
                });
        }
    }
})();
